import * as React from "react";
import {
  profileWrapper,
  profileInfo,
  title,
} from "./ProfileAddress.module.scss";
import Button from "react-bootstrap/Button";

export const ProfileWrapper: React.FC<any> = (props) => {
  return <div className={profileWrapper}>{props.children}</div>;
};
export const ProfileInfo: React.FC<{
  firstName: string;
  lastName: string;
  email: string;
  addressLine1?: string;
  city?: string;
  postalCode?: string;
  stateCode?: string;
  onEditProfile: any;
}> = (props) => {
  return (
    <div className={profileInfo} id="profile-details">
      <h5>{`${props.firstName} ${props.lastName}`}</h5>
      <div>
        <p>{props.email}</p>
        {props.addressLine1 ? <p>{props.addressLine1}</p> : ""}
        <p>
          {props.city}{" "}
          {props.city && (props.stateCode || props.postalCode) ? "," : ""}{" "}
          {props.stateCode} {props.postalCode}
        </p>
      </div>
      <Button
        id={"edit-profile-button"}
        variant="outline-dark"
        onClick={props.onEditProfile}
      >
        Edit Profile
      </Button>
    </div>
  );
};
export const ProfileTitle: React.FC<any> = (props) => {
  return (
    <h5 className={`pt-2 px-3 mb-0 styledProfileTitle ${title}`}>
      {props.children}
    </h5>
  );
};
